export * from 'cf-core/src/images'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const foodGallery =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1562131054/Shaolin/foodGallery.jpg'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1562129124/Shaolin/restaurant.jpg'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cflogo.png'
export const shaolinLogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1562132126/Shaolin/shaolinLogo.png'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/yelp.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/facebook.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/zomato.png'
export const email =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/email.png'
export const hero =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564367125/kiku/hero.jpg'
export const orderButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/orderButton.png'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/downloadButton.png'
export const logo =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564208094/kiku/logo.png'
export const locationMap =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/locationMap.jpg'
export const about =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564366890/kiku/about.png'
export const gallery =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564346671/kiku/gallery.png'
export const homebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564369746/kiku/homebg.jpg'
export const homebg2 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/homebg2.jpg'
export const interior =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564369660/kiku/interior.png'
export const contactbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/contactbg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/rewardbg.jpg'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/redeemButton.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/rewardArrowRight.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/pointsMeter.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1564179533/kiku/rewardDefault.png'
export const locationMapDowntown =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1572288563/kiku/locationMapDowntown.jpg'
export const metrotownLocationButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1572288697/kiku/metrotownLocationButton.png'
export const downtownLocationButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1572288696/kiku/downtownLocationButton.png'
export const interiorMetrotown =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1572288827/kiku/interiorMetrotown.png'
